import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TokenInterceptor } from '../interceptor/token.interceptor';
import { AttendanceFormComponent } from './attendance-form.component';
import { AttendanceFormService } from '../services/attendance-form.service';
import { RecaptchaModule } from 'ng-recaptcha';
import { DetailInfoFormPageStepsModule } from 'shared/detail-info-form-page-steps/detail-info-form-page-steps.module';
import { DetailInfoTypeModule } from 'shared/detail-info-type/detail-info-type.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AttendanceContactListModule } from 'shared/contact-list/contact-list.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({

  declarations: [AttendanceFormComponent],
  imports: [
    CommonModule, HttpClientModule, FormsModule, ReactiveFormsModule, BsDropdownModule,
    RecaptchaModule, SharedModule,
    DetailInfoTypeModule, DetailInfoFormPageStepsModule, AttendanceContactListModule
  ],
  exports: [AttendanceFormComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    AttendanceFormService
  ]
})
export class AttendanceFormModule { }
